import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class RevenueSubAccountForm extends Form {
  static contextType = PopUpContext;

  state = {
    data: {
      name: "",
      name_en: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { data } = this.state;

    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.name = edit.name;
      data.name_en = edit.name_en;
    }

    this.setState({ data });
  };

  schema = {
    name: Joi.string().max(128).required(),
    name_en: Joi.string().max(128).required(),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;
      let revenue_account_id = popUp.type;

      const __controls = this.cleanObject({
        ...this.state.data,
        revenue_account_id,
      });

      if (popUp?.edit?.id) {
        await db
          .edit(`revenues/subAccounts/${popUp.edit.id}`, __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((e) => {
            togglePopUp({
              form: "toast",
              message: e.toString(),
              type: "warning",
            });
          });
      } else {
        await db
          .save("revenues/subAccounts", __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((e) => {
            togglePopUp({
              form: "toast",
              message: e.toString(),
              type: "warning",
            });
          });
      }
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        console.log(errors);

        this.setState({ errors });
      }
    }
  };

  render() {
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditRenvenueType : lbl.AddRenvenueType}</p>
          </div>
          <div className="form-inputs">
            <div className="multi-input">
              {this.renderInput("name", "نام (فارسی)")}
              {this.renderInput("name_en", "نام (انگلیسی)")}
            </div>
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default RevenueSubAccountForm;
